import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    border-collapse: collapse;\n\n    ", "\n    ", "\n    ", "\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            table-layout: fixed;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            display: block;\n            overflow-x: auto;\n            white-space: nowrap;\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { heightAttributes, marginAttributes, widthAttributes } from '../../system/attributes';
import { getPropsBlocker } from '../../utils';
var propertyList = {
  horizontalScroll: true,
  selectedRowIds: true,
  onRowSelectionChange: true,
  enableFixedLayout: true
};

var getRootDynamicStyle = function getRootDynamicStyle(_ref) {
  var horizontalScroll = _ref.horizontalScroll,
      enableFixedLayout = _ref.enableFixedLayout,
      theme = _ref.theme;
  var Table = theme.componentOverrides.Table;
  var result = Table.Root.base;

  if (horizontalScroll) {
    result = css(_templateObject(), result);
  }

  if (enableFixedLayout) {
    result = css(_templateObject2(), result);
  }

  return result;
};

export var TableRoot = styled.table.withConfig(getPropsBlocker(propertyList))(_templateObject3(), getRootDynamicStyle, marginAttributes, widthAttributes, heightAttributes);